import * as React from 'react';
import { IAsidePanelActionsButtonsGroupInheritedProps } from './types';
import { AsidePanelContext } from '../AsidePanel/constants';

export function AsidePanelActionsButtonsGroup ({
    children,
    title,
}: IAsidePanelActionsButtonsGroupInheritedProps) {
    const className = 'aside-panel__actions-buttons-group';
    const { isMobile } = React.useContext(AsidePanelContext);
    const content = <>
        {title && <span className={className + '-subtitle'}>{title}</span>}
        {children}
    </>
    return (
       isMobile
           ? <div className={className}>{content}</div>
           :content
    );
};
